<!--会员一览列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">注册会员</span>
      </div>
    </div>
    <div class="filter-box">
      <div class="item_box">
        <Input style="width: 300px" v-model="page.value" placeholder="根据条件搜索">
          <Select v-model="page.cond" slot="prepend" style="width: 120px">
            <!-- <Option value="name">名称</Option> -->
            <!-- <Option value="tel">电话</Option> -->
            <Option value="account">ID账号</Option>
            <Option value="tel">手机/员工号</Option>
            <Option value="area">地区</Option>
          </Select>
        </Input>
        <span class="subtitle" style="margin-left: 10px">类型</span>
        <Select v-model="page.type" style="width: 120px; margin-left: 5px">
          <Option value="-1">全部</Option>
          <Option value="0">会员</Option>
          <Option value="1">企业员工</Option>
        </Select>
        <span class="subtitle" style="margin-left: 10px">注册时间</span>
        <DatePicker
          type="date"
          v-model="page.start"
          placeholder="开始时间"
          style="width: 120px"
        >
        </DatePicker>
        <span style="margin-left: 5px">至</span>
        <DatePicker
          type="date"
          v-model="page.end"
          placeholder="结束时间"
          style="width: 130px; margin-left: 5px"
        ></DatePicker>

        <span class="subtitle" style="margin-left: 10px">状态</span>
        <Select v-model="page.is_del" style="width: 100px; margin-left: 5px">
          <Option :value="0" style="text-align: center">正常</Option>
          <Option :value="1" style="text-align: center">禁用</Option>
        </Select>
      </div>
      <div class="bottom">
        <Poptip trigger="hover" title="筛选" content="content" placement="left">
          <Button icon="md-list-box" style="margin: 0 5px 1px 0"></Button>
          <div slot="content" class="group">
            <Button
              size="small"
              style="margin: 0 5px 5px 0"
              v-for="(item, index) in col"
              :key="index"
              :type="item.show ? 'primary' : 'default'"
              @click="item.show = !item.show"
            >
              <span>{{ item.title }}</span>
            </Button>
          </div>
        </Poptip>
        <span class="btn-filter" @click="tableLoading ? null : getData(1)">筛选</span>
        <span class="btn" @click="reset">清空</span>
        <Poptip title="导出Excel" placement="left" trigger="hover">
          <Button style="margin: 0 5px">导出Excel</Button>
          <div slot="content">
            <Button type="primary" style="margin-right: 5px" @click="exportData(0)"
              >导出当前页</Button
            >
            <!-- <Button type="success" @click="exportData(1)">导出所有页</Button> -->
          </div>
        </Poptip>
      </div>
    </div>

    <div>
      <Table
        :columns="columns"
        :data="data"
        :loading="tableLoading"
        @on-sort-change="tableSort"
      />
    </div>
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        :current="page.p + 1"
        show-elevator
        :page-size-opts="pageSizeOpts"
        show-sizer
        show-total
      />
    </div>
    <Modal v-model="modal" :width="800" :title="`用户信息 - ${current.name}`">
      <Tabs :animated="false" v-model="tabs" size="small" @on-click="tabsChange">
        <!-- <TabPane label="充值">
          <Row>
            <Col :span="3" style="line-height: 32px">充值金额:</Col>
            <Col :span="5"><InputNumber :active-change="false" :precision="2" :min="0.01" v-model="recharge.money" placeholder="充值金额"/></Col>
            <Col :span="3" style="line-height: 32px">充值备注:</Col>
            <Col :span="9"><Input v-model="recharge.note" placeholder="充值备注"/></Col>
            <Col :span="4" style="text-align:right"><Button type="primary" @click="doRecharge" :loading="recharge_loading">充值</Button></Col>
          </Row>
                            </TabPane> -->
        <TabPane label="清零">
          <Row>
            <Col :span="3">钱包余额:</Col>
            <Col :span="5">{{ userMoney.money }}</Col>
            <Col :span="4" style="text-align: right"
              ><Button type="primary" @click="clearUserMoney" :loading="recharge_loading"
                >立即清零</Button
              ></Col
            >
          </Row>
        </TabPane>
        <TabPane label="充值记录">
          <Table
            size="small"
            :height="300"
            :columns="recharge_col"
            :data="recharge.logs"
            :loading="rechargeTableLoading"
          />
        </TabPane>
        <TabPane label="消费记录">
          <Table
            size="small"
            :height="300"
            :columns="consumption_columns"
            :data="consumption_data"
            :loading="consumption_loading"
          />
        </TabPane>

        <TabPane label="赠券" v-if="user.tp === 0">
          <Form :label-width="80">
            <FormItem label="优惠券">
              <Select v-model="sendCoupon.coupon_id" placement="bottom" :transfer="true">
                <Option v-for="item in couponData" :value="item.id" :key="item.id">{{
                  item.name
                }}</Option>
              </Select>
            </FormItem>
            <FormItem label="数量">
              <InputNumber :max="10" :min="1" v-model="sendCoupon.number"></InputNumber>
            </FormItem>
            <FormItem label="">
              <Button type="primary" :loading="sendCoupon.loading" @click="sendUserCoupon"
                >立即赠送</Button
              >
            </FormItem>
          </Form>

          <!-- 赠送记录 -->
          <div class="gift-records">
            <div class="gift-records-title">赠送记录</div>
            <div v-if="giftLogs.length === 0" class="gift-records-empty">暂无记录</div>
            <div v-else class="gift-records-list">
              <div v-for="(log, index) in giftLogs" :key="index" class="gift-item">
                <div class="gift-left">
                  <div class="gift-name">{{ log.name }}</div>
                  <div class="gift-time">{{ log.time }}</div>
                </div>
                <div class="gift-amount">￥{{ log.money }}</div>
              </div>
            </div>
          </div>
        </TabPane>
      </Tabs>
      <div slot="footer">
        <Button @click="modal = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
import { verifyDate, monDiff } from '@/libs/util'

export default {
  data () {
    return {
      consumption_loading: false,
      consumption_columns: [
        { key: 'id', width: 100, title: '编号' },
        { key: 'money', width: 60, title: '金额' },
        {
          key: 'create_time',
          width: 135,
          title: '消费时间',
          render: (h, data) => {
            return h('span', this.$moment(data.row.create_time))
          }
        },
        { key: 'order_no', title: '订单号' },
        { key: 'log', title: '日志' },
        { key: 'job_ids', title: '任务编号' }
      ],
      consumption_data: [],
      page: {
        p: 0,
        l: 10,
        cond: 'account',
        value: '',
        is_del: 0,
        key: 'id',
        order: 'desc',
        start: '',
        end: '',
        type: '-1'
      },
      pageSizeOpts: [10, 50, 100, 150],
      data: [],
      total: 0,
      tableLoading: false,
      modal: false,
      tabs: 0,
      recharge: {
        user_id: 0,
        money: 1,
        note: '',
        logs: [] // 充值记录数据
      }, // 充值
      recharge_loading: false,
      current: {}, // 模态框当前会员
      col: [
        {
          key: 'create_time',
          title: '注册时间',
          show: true,
          fixed: 'left',
          width: 135,
          render: (h, data) => {
            return h('span', {}, this.$moment(data.row.create_time))
          }
        },
        // { title: '编号',fixed: 'left',width: 85,sortable: 'custom', key: 'id', show: true },
        { title: 'ID账号', fixed: 'left', width: 110, key: 'account', show: true },
        { title: '手机/员工号', fixed: 'left', width: 110, key: 'tel', show: true },
        {
          title: '类型',
          key: 'is_staff',
          sortable: 'custom',
          fixed: 'left',
          width: 90,
          show: true,
          render: (h, data) => {
            return h('span', {}, data.row.is_staff ? '企业员工' : '会员')
          }
        },

        { title: '余额', key: 'money', width: 90, show: true, fixed: 'left' },
        { title: '昵称', key: 'name', width: 180, show: true },
        {
          title: '性别',
          key: 'gender',
          width: 80,
          show: true,
          render: (h, data) => {
            return h(
              'span',
              data.row.gender ? (data.row.gender === 1 ? '男' : '未知') : '女'
            )
          }
        },
        { title: '电话', key: 'phone', width: 110, show: true },
        {
          title: '生日',
          key: 'birthday',
          width: 110,
          show: true,
          render: (h, data) => {
            return h('span', {}, this.$moment(data.row.create_time, 'YYYY-MM-DD'))
          }
        },
        { title: '邮箱', key: 'email', width: 110, show: true, tooltip: true },
        { title: '地区', key: 'area', width: 110, show: true, tooltip: true },
        {
          title: '企业',
          key: 'company_name',
          width: 110,
          show: true,
          tooltip: true
        },
        {
          title: '微信绑定',
          key: 'app_openid',
          width: 105,
          sortable: 'custom',
          show: true,
          render: (h, data) => {
            return h(
              'span',
              {
                style: {
                  color:
                    data.row.app_openid || data.row.xcx_openid || data.row.union_id
                      ? '#19be6b'
                      : '#ed4014'
                }
              },
              data.row.app_openid || data.row.xcx_openid || data.row.union_id
                ? '已绑定'
                : '未绑定'
            )
          }
        },
        {
          title: '钉钉绑定',
          key: 'dd_openid',
          width: 105,
          sortable: 'custom',
          show: true,
          render: (h, data) => {
            return h(
              'span',
              { style: { color: data.row.dd_openid ? '#19be6b' : '#ed4014' } },
              data.row.dd_openid ? '已绑定' : '未绑定'
            )
          }
        },
        {
          title: '有效打印券余量',
          width: 130,
          key: 'coupon_hold',
          show: true,
          render: (h, data) => {
            return h('span', {}, data.row.coupon_hold ? data.row.coupon_hold : '0')
          }
        },
        {
          title: '状态',
          key: 'is_del',
          width: 90,
          show: true,
          render: (h, data) => {
            return h(
              'span',
              { style: { color: data.row.is_del ? '#ed4014' : '#19be6b' } },
              data.row.is_del ? '禁用' : '正常'
            )
          }
        },
        {
          title: '最后登录时间',
          key: 'login_time',
          width: 135,
          show: true,
          render: (h, data) => {
            return h(
              'span',
              {},
              data.row.login_time ? this.$moment(data.row.login_time) : '-'
            )
          }
        },
        {
          title: '最后作业时间',
          width: 135,
          key: 'work_time',
          show: true,
          render: (h, data) => {
            return h(
              'span',
              {},
              data.row.work_time ? this.$moment(data.row.work_time) : '-'
            )
          }
        }
        // {
        //   title: "消费总额",
        //   key: "aid_total",
        //   width: 90,
        //   show: true,

        //     render: (h, data) => {
        //       return h('span', {}, data.row.total_money?data.row.total_money:"-")
        //     }
        // },
        // { title: '微信绑定',
        //   key: 'open_id',
        //   sortable: 'custom',
        //   show: true,
        //   render: (h, data) => {
        //     return h('span', { style: { color: data.row.open_id ? '#19be6b' : '#ed4014' } }, data.row.open_id ? '已绑定' : '未绑定')
        //   } },
        // { title: '硬盘使用量',
        //   key: 'free_space',
        //   sortable: 'custom',
        //   show: true,
        //   render: (h, data) => {
        //     return h('span', {}, `${parseFloat(data.row.free_space / 1024).toFixed(2)}M/${data.row.disk_space / 1024}M`)
        //   } }
      ],
      end: [
        {
          title: '操作',
          key: 'operator',
          fixed: 'right',
          width: 122,
          render: (h, data) => {
            return h('div', [
              h(
                'Button',
                {
                  props: {
                    type: `${data.row.is_del ? 'success' : 'error'}`,
                    size: 'small'
                  },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: `${data.row.is_del ? '启用' : '禁用'}`,
                        content: `是否${data.row.is_del ? '启用' : '禁用'}此会员`,
                        onOk: () => {
                          let temp = JSON.parse(JSON.stringify(data.row))
                          delete temp._index
                          delete temp._rowKey
                          delete temp.create_time
                          temp.is_del = temp.is_del ? 0 : 1
                          this.saveUser({ id: temp.id, is_del: temp.is_del })
                        }
                      })
                    }
                  }
                },
                `${data.row.is_del ? (data.row.is_del < 0 ? '通过' : '启用') : '禁用'}`
              ),
              h(
                'Button',
                {
                  props: { type: 'warning', size: 'small' },
                  on: {
                    click: () => {
                      // 打开模态框 用选项卡列出 充值 充值记录 消费记录
                      if (data.row.is_staff) {
                        this.$Message.warning('企业员工不可编辑')
                        return false
                      }
                      this.modal = true
                      this.current = data.row
                      this.tabs = 0
                      this.recharge = {
                        user_id: data.row.id,
                        money: 1,
                        note: ''
                      }
                      this.userMoney = {
                        user_id: data.row.id,
                        money: data.row.money
                      }
                      this.sendCoupon.user_id = data.row.id
                      // 打开编辑弹窗时，预加载赠送记录
                      if (this.user.tp === 0) this.fetchGiftLogs()
                    }
                  }
                },
                '编辑'
              )
            ])
          }
        }
      ],
      userMoney: {
        user_id: 0,
        money: 0
      },
      columns: [],
      recharge_col: [
        { title: '编号', width: 100, key: 'id' },
        {
          title: '充值时间',
          width: 135,
          key: 'create_time',
          render: (h, data) => {
            return h('span', {}, this.$moment(data.row.create_time))
          }
        },
        { title: '金额', key: 'money' },
        { title: '支付单号', key: 'order_no', tooltip: true, width: 200 },
        { title: '备注', key: 'note', tooltip: true },
        {
          title: '充值方式',
          key: 'type',
          render: (h, data) => {
            switch (data.row.type) {
              case 0:
                return h('span', {}, '人工')
              case 1:
                return h('span', {}, '支付宝')
              case 2:
                return h('span', {}, '微信')
            }
          }
        }
      ], // 充值记录列
      rechargeTableLoading: false, // 充值记录表格加载
      couponData: [],
      sendCoupon: {
        coupon_id: 0,
        number: 1,
        loading: false,
        user_id: 0
      },
      // 赠送记录（当前会话内）
      giftLogs: []
    }
  },
  methods: {
    tableSort (col) {
      this.page.key = col.key
      this.page.order = col.order
      this.getData()
    },
    tabsChange (tab) {
      switch (tab) {
        case 1: // 查询充值记录
          this.rechargeTableLoading = true
          this.userRecharge({ p: 0, l: 10000, id: this.current.id }).then((res) => {
            this.recharge.logs = res
            this.rechargeTableLoading = false
          })
          break
        case 2: // 查询消费记录
          this.consumption_loading = true
          this.UserConsumptionRecord({ id: this.current.id }).then((res) => {
            this.consumption_data = res
            this.consumption_loading = false
          })
          break
        case 3: // 查询赠送记录
          this.fetchGiftLogs()
          break
      }
    },
    // 执行充值
    doRecharge () {
      this.recharge_loading = true
      this.rechargeDo(this.recharge).then((res) => {
        if (res) {
          this.getData()
          this.recharge_loading = false
          this.$Message.success('充值成功!')
        }
      })
    },
    // 格式化表格
    formatCol () {
      let temp = []
      this.col.map((item) => {
        if (item.show) {
          temp.push(item)
        }
      })
      this.columns = temp.concat(this.end)
    },
    // 重置查询
    reset () {
      this.page = {
        p: 0,
        l: 10,
        cond: 'tel',
        value: '',
        is_del: 0,
        key: 'id',
        order: 'desc',
        start: '',
        end: '',
        type: '-1'
      }
      this.page.start = this.$moment(new Date(), 'YYYY-MM-DD')
      this.page.end = this.$moment(new Date(), 'YYYY-MM-DD')
      this.getData(1)
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    getData (filter) {
      if (filter) {
        this.page.p = 0
      }
      let cond = JSON.parse(JSON.stringify(this.page))
      if (this.page.type != '-1') {
        cond.is_staff = this.page.type
      }
      if (this.page.start && this.page.end) {
        /*  if (verifyDate(this.page.start, this.page.end)) {
          this.$Message.error("开始时间不能大于结束时间");
          return;
        } */
        if (
          this.page.start &&
          this.page.end &&
          verifyDate(this.page.start, this.page.end)
        ) {
          this.$Message.error('开始时间不能大于结束时间')
          return
        }
        /* if (monDiff(this.page.start, this.page.end) > 12) {
          //如果时间跨度超过一年就提示
          this.$Message.error("筛选的时间跨度不能超过1年");
          return;
        } */

        cond.start = this.$moment(this.page.start, 'YYYY-MM-DD')
        cond.end = this.$moment(this.page.end, 'YYYY-MM-DD')
      }
      this.tableLoading = true

      this.getUsers(cond).then((res) => {
        if (this.user.tp) {
          res.data.map((item) => {
            if (item.tel) {
              item.tel =
                item.tel.substr(0, 3) + '****' + item.tel.substr(7, item.tel.length)
            }
          })
        }
        this.data = res.data
        this.total = res.total
        this.tableLoading = false
      })
    },
    // 格式化数据
    excelData (data) {
      data = JSON.parse(JSON.stringify(data))
      data.map((item) => {
        item.gender = item.gender ? '男' : '女'
        item.is_del = item.is_del ? '禁用' : '正常'
        item.create_time = this.$moment(item.create_time)
        item.open_id = item.open_id ? '已绑定' : '未绑定'
        item.free_space = `${item.free_space / 1024}M/${item.disk_space / 1024}M`
        item.is_staff = item.is_staff ? '员工' : '会员'
        item.login_time = item.login_time ? this.$moment(item.login_time) : ''
        item.work_time = item.work_time ? this.$moment(item.work_time) : ''
      })
      return data
    },
    // 导出数据
    exportData (is_all) {
      let title = [],
        key = []
      this.col.map((item) => {
        if (item.show) {
          title.push(item.title)
          key.push(item.key)
        }
      })
      let params = {
        title: title,
        key: key,
        autoWidth: true,
        filename: '注册会员列表'
      }
      if (is_all) {
        let page = JSON.parse(JSON.stringify(this.page))
        page.l = this.total
        page.p = 0
        this.getUsers(page).then((res) => {
          params.data = this.excelData(res.data)
          excel.export_array_to_excel(params)
        })
      } else {
        this.data.map((item) => {
          item.app_openid = item.app_openid ? '已绑定' : '未绑定'
          item.dd_openid = item.dd_openid ? '已绑定' : '未绑定'
        })
        params.data = this.excelData(this.data)
        excel.export_array_to_excel(params)
      }
    },
    saveUser (data) {
      this.putUser(data).then((res) => {
        this.data.map((item) => {
          if (item.id === data.id) {
            item.is_del = data.is_del
          }
        })
      })
    },
    clearUserMoney () {
      this.recharge_loading = true
      this.ClearUserMoney({ user_id: this.userMoney.user_id })
        .then((res) => {
          this.recharge_loading = false
          if (res.status) {
            this.getData()
            this.$Message.success('操作成功!')
            this.userMoney.money = 0
          } else {
            this.$Message.error(res.msg)
          }
        })
        .catch((e) => {
          this.recharge_loading = false
          this.$Message.error('系统错误')
        })
    },
    getCoupon () {
      this.getCouponAll().then((res) => {
        this.couponData = res.data
      })
    },
    sendUserCoupon () {
      const data = {
        coupon_id: this.sendCoupon.coupon_id,
        number: this.sendCoupon.number,
        user_id: this.sendCoupon.user_id
      }
      if (!data.user_id) {
        this.$Message.error('参数错误')
        return false
      }
      if (!data.coupon_id) {
        this.$Message.error('请选择要赠送的优惠券')
        return false
      }
      if (!data.number || data.number > 10 || data.number < 1) {
        this.$Message.error('请填写正确的数量')
        return false
      }
      this.sendCoupon.loading = true
      this.SendUserCoupon(data).then((res) => {
        this.sendCoupon.loading = false
        this.$Message[res.status ? 'success' : 'error'](res.msg)
        if (res.status) {
          // 重置表单
          this.sendCoupon.coupon_id = 0
          this.sendCoupon.number = 1
          // 查找券信息，记录赠送日志
          const couponInfo = this.couponData.find((c) => c.id === data.coupon_id)
          this.giftLogs.unshift({
            name: couponInfo ? couponInfo.name : `优惠券#${data.coupon_id}`,
            money: couponInfo && couponInfo.money !== undefined ? couponInfo.money : '-',
            time: this.$moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
          })
        }
      })
    },
    /**
     * 获取赠送记录
     * - 调用 GetGiftCouponRecords 接口
     * - 规范化为 giftLogs 列表字段：name/money/time
     */
    fetchGiftLogs () {
      const user_id = this.sendCoupon.user_id || (this.current && this.current.id)
      if (!user_id) {
        this.giftLogs = []
        return
      }
      this.GetGiftCouponRecords({ user_id }).then((res) => {
        // 兼容不同响应结构：res、res.data、res.data.list
        const raw = res || {}
        const data = raw.data || raw
        const list = Array.isArray(data)
          ? data
          : Array.isArray(data.list)
            ? data.list
            : Array.isArray(data.rows)
              ? data.rows
              : []
        this.giftLogs = list.map((item) => ({
          name:
            item.coupon_name || item.name || item.coupon || `优惠券#${item.print_coupon_id || item.coupon_id || ''}`,
          money:
            item.money !== undefined
              ? item.money
              : item.coupon_money !== undefined
                ? item.coupon_money
                : item.amount !== undefined
                  ? item.amount
                  : '-',
          time: this.$moment(
            item.create_time || item.time || item.gift_time,
            'YYYY-MM-DD HH:mm:ss'
          )
        }))
      })
    },
    ...mapActions([
      'getUsers',
      'putUser',
      'rechargeDo',
      'userRecharge',
      'UserConsumptionRecord',
      'ClearUserMoney',
      'getCouponAll',
      'SendUserCoupon',
      'GetGiftCouponRecords'
    ])
  },
  mounted () {
    // this.page.start = this.$moment(new Date(), "YYYY-MM-DD");
    // this.page.end = this.$moment(new Date(), "YYYY-MM-DD");
    this.getData()
    this.formatCol()
    if (this.user.tp === 0) this.getCoupon()
  },
  computed: mapGetters({
    user: 'agent'
  }),
  watch: {
    col: {
      handler (n, o) {
        this.formatCol()
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";

/* 赠送记录样式 */
.gift-records {
  margin-top: 16px;
  padding: 10px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
}
.gift-records-title {
  font-size: 14px;
  color: #333;
  margin-bottom: 8px;
}
.gift-records-empty {
  color: #999;
  font-size: 13px;
}
.gift-records-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.gift-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}
.gift-left {
  display: flex;
  flex-direction: column;
}
.gift-name {
  font-weight: 600;
  color: #333;
}
.gift-time {
  font-size: 12px;
  color: #888;
}
.gift-amount {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
</style>

/**
 * 获取赠送记录
 * - 调用 GetGiftCouponRecords 接口
 * - 规范化为 giftLogs 列表字段：name/money/time
 */
fetchGiftLogs() {
  const user_id = this.sendCoupon.user_id || (this.current && this.current.id);
  if (!user_id) {
    this.giftLogs = [];
    return;
  }
  this.GetGiftCouponRecords({ user_id }).then((res) => {
    const list = Array.isArray(res) ? res : (res && res.data ? res.data : []);
    this.giftLogs = list.map((item) => ({
      name:
        item.coupon_name || item.name || item.coupon || `优惠券#${item.coupon_id || ""}`,
      money:
        item.money !== undefined
          ? item.money
          : item.coupon_money !== undefined
          ? item.coupon_money
          : item.amount !== undefined
          ? item.amount
          : "-",
      time: this.$moment(
        item.create_time || item.time || item.gift_time,
        "YYYY-MM-DD HH:mm:ss"
      ),
    }));
  });
},
],
